// Core
import React, { useState } from 'react';

// Imgs
import passwordHideImg from '../../../assets/icons/input-password-hide-icon.svg';
import passwordShowImg from '../../../assets/icons/input-password-show-icon.svg';

// Styles
import styles from './Input.module.css';

export default function Input(props) {
  const {
    elementType,
    elementConfig: initialElementConfig,
    name,
    value,
    changed,
    invalid,
    shouldValidate,
    touched,
    error,
    label,
    inputLabelStyle,
    inputFieldWrapperStyle,
    inputWrapRef,
    doNotCopyPast,
    blur,
  } = props;
  const [elementConfig, setElementConfig] = useState(initialElementConfig);
  const isPasswordField =
    initialElementConfig && initialElementConfig.type === 'password';
  const isPasswordRevealed =
    isPasswordField && elementConfig.type !== 'password';

  let inputElement = null;
  const inputClasses = [styles.InputElement];
  const inputElementSpanClasses = [styles.inputElementSpanClasses];

  if (invalid && shouldValidate && touched) {
    inputClasses.push(styles.Invalid);

    // Do not add red cross if its password field
    // because it has own eye icon on the same place
    if (!isPasswordField) {
      inputElementSpanClasses.push(styles.Invalid);
    }
  }

  const togglePassword = () => {
    setElementConfig((prevState) => {
      return {
        ...prevState,
        type: prevState.type === 'password' ? 'text' : 'password',
      };
    });
  };

  switch (elementType) {
    case 'input':
      inputElement = (
        <input
          name={name}
          className={inputClasses.join(' ')}
          style={isPasswordField ? { paddingRight: '30px' } : null}
          {...elementConfig}
          value={value}
          onChange={changed}
          {...(doNotCopyPast && {
            onCopy: (e) => e.preventDefault(),
            onPaste: (e) => e.preventDefault(),
            onCut: (e) => e.preventDefault(),
          })}
          onBlur={blur}
        />
      );
      break;
    case 'textarea':
      inputElement = (
        <textarea
          name={name}
          className={inputClasses.join(' ')}
          {...elementConfig}
          value={value}
          onChange={changed}
        />
      );
      break;
    case 'checkbox':
      inputElement = (
        <input
          name={name}
          className={inputClasses.join(' ')}
          {...elementConfig}
          value={value}
          onChange={changed}
        />
      );
      break;
    case 'select':
      inputElement = (
        <select
          name={name}
          className={inputClasses.join(' ')}
          value={value}
          onChange={changed}
          onBlur={() => {}}
        >
          {elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    default:
      inputElement = (
        <input
          name={name}
          className={inputClasses.join(' ')}
          {...elementConfig}
          value={value}
          onChange={changed}
        />
      );
  }

  if (isPasswordField) {
    inputElement = (
      <>
        {inputElement}
        <button
          type="button"
          onClick={togglePassword}
          className={styles.togglePasswordBtn}
          data-tip={isPasswordRevealed ? 'Hide password' : 'Show password'}
          tabIndex="-1"
        >
          <img
            src={isPasswordRevealed ? passwordHideImg : passwordShowImg}
            alt="Toggle Password"
          />
        </button>
      </>
    );
  }

  return (
    <div
      className={styles.Input}
      style={elementConfig.type === 'hidden' ? { display: 'none' } : null}
      ref={inputWrapRef}
    >
      <div className={styles.Label} style={inputLabelStyle}>
        {label}
      </div>
      <div
        className={styles.InputElementWrapper}
        style={inputFieldWrapperStyle}
      >
        <span className={inputElementSpanClasses.join(' ')}>
          {inputElement}
        </span>
        <div
          className={`${styles.InputElementError}${
            name === 'email' ? ` ${styles.NoClip}` : ''
          }`}
        >
          {error}
        </div>
      </div>
    </div>
  );
}
